import i18n from 'services/base/i18n';

export default {
  /* If the user decides to activate their pangolin by a secret activation phrase packaged with
  the Pangolin, this tells them to look for the activation phrase and type it into this page */
  instructions: () => i18n.pgettext('Pages|Add Pangolin|Mnemonic', 'Please enter the activation phrase found on your Pangolin'),

  // Placeholder text for the input box where they input the activation phrase
  placeholder: () => i18n.pgettext('Pages|Add Pangolin|Mnemonic', 'Enter your activation phrase'),

  // The button to submit the activation phrase
  submit: () => i18n.pgettext('Pages|Add Pangolin|Mnemonic', 'SUBMIT'),
};
